export default __webpack_public_path__ + "static/media/icon10.0e73ff47.png";